<template>
  <v-card>
    <v-card-title class="primary white--text">
      {{$t('editStatus')}}
      <v-spacer></v-spacer>
      <Icon
      :small="false"
      large
      icon="mdi-close"
      iconColor="white"
      :tooltipText="$t('close')"
      @icon-clicked="close"
      />
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="status"
        :items="statuses"
        :menu-props="{ bottom: true, offsetY: true }"
        class="mt-6"
        item-text="name"
        item-value="name"
        return-object
        color="black"
      />
    </v-card-text>
    <v-card-actions>
      <v-container fluid class="px-0">
        <v-row justify="end">
          <v-col cols="auto" class="px-0">
            <v-btn class="primary" @click="saveChanges">
              {{$t('saveChanges')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { TractStatus } from '@/utils/Enumerations.js'
import { mapActions } from 'vuex'
export default {
  name: 'EditTractStatus',

  props: {
    tract: {
      type: Object,
      required: true
    },
    propStatus: {
      type: Number,
      required: true
    }
  },

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    status: null
  }),

  computed: {
    statuses () {
      const ts = TractStatus
      const status = ts.forInt(this.propStatus)
      let statusesToInclude = []

      switch (status.value) {
        case ts.Initiated.value:
        case ts.Cruised.value:
        case ts.Executed.value:
          statusesToInclude = [
            ts.Initiated.value,
            ts.Cruised.value,
            ts.Executed.value,
            ts.Closed.value,
            ts.Archived.value
          ]
          break

        case ts.Active.value:
          statusesToInclude = [
            ts.Active.value,
            ts.Closed.value
          ]
          break

        case ts.Closed.value:
          statusesToInclude = [
            ts.Active.value,
            ts.Closed.value,
            ts.Archived.value
          ]
          break

        case ts.Archived.value:
          statusesToInclude = [
            ts.Archived.value,
            ts.Closed.value
          ]
          break
      }

      return ts.enums.filter(s => statusesToInclude.includes(s.value))
    }
  },

  mounted () {
    this.status = this.statuses.find(s => s.value === this.propStatus)
  },

  methods: {
    ...mapActions('tract', ['updateTract']),
    async saveChanges () {
      if (this.status.value === this.propStatus) {
        this.$emit('close')
        return
      }

      const request = {
        ...this.tract,
        status: this.status.value
      }

      await this.updateTract(request)

      this.$emit('close', this.status.value)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
